import { render, staticRenderFns } from "./NorticTab.vue?vue&type=template&id=8e2cba14&scoped=true&"
import script from "./NorticTab.vue?vue&type=script&lang=js&"
export * from "./NorticTab.vue?vue&type=script&lang=js&"
import style0 from "./NorticTab.vue?vue&type=style&index=0&id=8e2cba14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2cba14",
  null
  
)

export default component.exports